import { useState, useEffect } from 'react';
import { Maximize2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import './Gallery.css';

export default function Gallery() {
  const [dbGalleryData, setDbGalleryData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState('mco2026');
  const [filter, setFilter] = useState('all');
  const [zoomedImage, setZoomedImage] = useState(null);

  // Close lightbox on escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setZoomedImage(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    fetch('/api/cms/gallery')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setDbGalleryData(data);
      })
      .catch(console.error);
  }, []);

  const staticEvents = [
    { id: 'mco2026', name: 'MCO 2026' },
  ];

  const staticCategories = [
    { id: 'all', name: 'All Photos' },
    { id: 'mco_news', name: 'Newspaper Highlights' },
    { id: 'mco_awards', name: 'Award Ceremony' },
    { id: 'mco_ceremony', name: 'Ceremony' },
    { id: 'mco_exam', name: 'Examination' },
  ];

  const staticPhotos = [
    // Newspaper Highlights
    { id: 'n1', event: 'mco2026', category: 'mco_news', title: 'Dainak Bhaskar', src: '/gallery/mco2026/Dainak Bhaskar Newspaper.jpg' },
    { id: 'n2', event: 'mco2026', category: 'mco_news', title: 'Hindustan', src: '/gallery/mco2026/Hindustan Newspaper.jpg' },
    { id: 'n3', event: 'mco2026', category: 'mco_news', title: 'Mathura Jagran', src: '/gallery/mco2026/Mathura Jagran Newspaper.jpg' },
    { id: 'n4', event: 'mco2026', category: 'mco_news', title: 'Unique Samay', src: '/gallery/mco2026/Unique Samay Newspaper.jpg' },
    { id: 'n5', event: 'mco2026', category: 'mco_news', title: 'Amar Ujala', src: '/gallery/mco2026/Amar Ujala Newspaper.jpg' },
    { id: 'n6', event: 'mco2026', category: 'mco_news', title: 'Choti Si Baat', src: '/gallery/mco2026/Choti SI Baat Newspaper.jpeg' },

    // Award Ceremony
    { id: 'a1', event: 'mco2026', category: 'mco_awards', title: 'Awards Display', src: '/gallery/mco2026/Awards.JPG' },
    { id: 'a2', event: 'mco2026', category: 'mco_awards', title: 'Top 3 Winners', src: '/gallery/mco2026/All3Winners.JPG' },
    { id: 'a3', event: 'mco2026', category: 'mco_awards', title: 'Top 3 Winners Felicitation', src: '/gallery/mco2026/All3Winners2.JPG' },
    { id: 'a4', event: 'mco2026', category: 'mco_awards', title: 'First Place Winner', src: '/gallery/mco2026/Winner1.JPG' },
    { id: 'a5', event: 'mco2026', category: 'mco_awards', title: 'Second Place Winner', src: '/gallery/mco2026/Winner2.jpg' },
    { id: 'a6', event: 'mco2026', category: 'mco_awards', title: 'Third Place Winner', src: '/gallery/mco2026/Winner3.JPG' },
    { id: 'a7', event: 'mco2026', category: 'mco_awards', title: 'Highest Participation Trophy', src: '/gallery/mco2026/HighestparticipationTrophy.JPG' },
    { id: 'a8', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation1.JPG' },
    { id: 'a9', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation2.JPG' },
    { id: 'a10', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation3.JPG' },
    { id: 'a11', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation4.JPG' },
    { id: 'a12', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation5.JPG' },
    { id: 'a13', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation6.JPG' },
    { id: 'a14', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation7.JPG' },
    { id: 'a15', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation8.JPG' },
    { id: 'a16', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation9.JPG' },
    { id: 'a17', event: 'mco2026', category: 'mco_awards', title: 'Consolation Award Winner', src: '/gallery/mco2026/Consolation10.jpg' },

    // Ceremony
    { id: 'c1', event: 'mco2026', category: 'mco_ceremony', title: 'Inauguration Moments', src: '/gallery/mco2026/Ceremony-2.JPG' },
    { id: 'c2', event: 'mco2026', category: 'mco_ceremony', title: 'Addressing the Gathering', src: '/gallery/mco2026/Ceremony-3.JPG' },
    { id: 'c3', event: 'mco2026', category: 'mco_ceremony', title: 'Student Participation', src: '/gallery/mco2026/Ceremony-4.JPG' },
    { id: 'c4', event: 'mco2026', category: 'mco_ceremony', title: 'Student Participation', src: '/gallery/mco2026/Ceremony-5.JPG' },
    { id: 'c5', event: 'mco2026', category: 'mco_ceremony', title: 'Ceremony Highlights', src: '/gallery/mco2026/Ceremony-8.JPG' },
    { id: 'c6', event: 'mco2026', category: 'mco_ceremony', title: 'Event Proceedings', src: '/gallery/mco2026/Ceremony -9.JPG' },

    // Examination
    { id: 'e1', event: 'mco2026', category: 'mco_exam', title: 'Students Focused During Exam', src: '/gallery/mco2026/Students Participating -1.JPG' },
    { id: 'e2', event: 'mco2026', category: 'mco_exam', title: 'Examination Hall Overview', src: '/gallery/mco2026/Students Participating -2.JPG' },
    { id: 'e3', event: 'mco2026', category: 'mco_exam', title: 'Active Participation', src: '/gallery/mco2026/Students Participating -3.JPG' },
    { id: 'e4', event: 'mco2026', category: 'mco_exam', title: 'MCO Examination in Progress', src: '/gallery/mco2026/Students Participating -4.JPG' },
  ];

  let mergedEvents = [...staticEvents];
  let mergedCategories = [...staticCategories];
  let mergedPhotos = [...staticPhotos];

  dbGalleryData.forEach(dbEvent => {
    let ev = mergedEvents.find(e => e.name === dbEvent.name);
    if (!ev) {
      ev = { id: `db_ev_${dbEvent.id}`, name: dbEvent.name };
      mergedEvents.push(ev);
    }
    
    dbEvent.tabs?.forEach(dbTab => {
       let cat = mergedCategories.find(c => c.name === dbTab.name);
       if (!cat) {
         cat = { id: `db_tab_${dbTab.id}`, name: dbTab.name };
         mergedCategories.push(cat);
       }
       
       dbTab.photos?.forEach(dbPhoto => {
         mergedPhotos.push({
           id: `db_ph_${dbPhoto.id}`,
           event: ev.id,
           category: cat.id,
           title: dbPhoto.title,
           src: dbPhoto.image_data
         });
       });
    });
  });

  const eventPhotos = mergedPhotos.filter(photo => photo.event === selectedEvent);
  const eventCategoryIds = new Set(eventPhotos.map(p => p.category));
  const activeCategories = [
    { id: 'all', name: 'All Photos' }, 
    ...mergedCategories.filter(c => eventCategoryIds.has(c.id) && c.id !== 'all')
  ];

  const filteredPhotos = filter === 'all' 
    ? eventPhotos 
    : eventPhotos.filter(photo => photo.category === filter);

  return (
    <div className="gallery-page">
      <Helmet>
        <title>Gallery | Dynamic Exams</title>
        <meta name="description" content="Explore photos and moments from our past Olympiads, award ceremonies, and educational events." />
        <meta property="og:title" content="Gallery | Dynamic Exams" />
        <meta property="og:description" content="Explore photos and moments from our past Olympiads and educational events." />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Gallery</h1>
        </div>
      </div>

      <section className="section-padding">
        <div className="container">
          
          <div className="event-tabs">
            {mergedEvents.map(event => (
              <button
                key={event.id}
                className={`btn ${selectedEvent === event.id ? 'btn-primary' : 'btn-outline'}`}
                onClick={() => {
                  setSelectedEvent(event.id);
                  setFilter('all');
                }}
              >
                {event.name}
              </button>
            ))}
          </div>

          <div className="gallery-filters">
            {activeCategories.map(cat => (
              <button
                key={cat.id}
                className={`filter-btn ${filter === cat.id ? 'active' : ''}`}
                onClick={() => setFilter(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>

          <div className="gallery-grid">
            {filteredPhotos.map(photo => (
              <div key={photo.id} className="gallery-item glass-panel" onClick={() => setZoomedImage(photo)} style={{ cursor: 'pointer' }}>
                <div className="gallery-image-container">
                  <img src={photo.src} alt={photo.title} loading="lazy" />
                  <div className="gallery-overlay">
                    <Maximize2 size={24} className="gallery-icon-hover" />
                  </div>
                </div>
                <div className="gallery-caption">
                  <h4>{photo.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Overlay */}
      <div className={`lightbox-overlay ${zoomedImage ? 'active' : ''}`} onClick={() => setZoomedImage(null)}>
        {zoomedImage && (
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setZoomedImage(null)} aria-label="Close image">
              &times;
            </button>
            <img src={zoomedImage.src} alt={zoomedImage.title} className="lightbox-image" />
          </div>
        )}
      </div>
    </div>
  );
}
